import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IDictionary } from 'src/app/shared/interfaces/models/idictionary.model';
import { GlobalRef } from '../../shared/globals/global-ref';
import { IEntityValidation } from '../../shared/interfaces/models/ientity-validation.model';
import { IPageableList } from '../../shared/interfaces/models/ipageable-list.model';
import { AppSettings } from '../../shared/models/appsettings';
import { DictionaryBaseService } from '../../shared/services/dictionary-base.service';
import { UserContextService } from '../../shared/services/user-context.service';
import { IWorkflowTagQuery } from './iworkflow-tag-query.model';
import { IWorkflowTag } from './iworkflow-tag.model';

@Injectable({
  providedIn: 'root',
})
export class WorkflowTagsService extends DictionaryBaseService<IWorkflowTag> {

  constructor(globalContext: GlobalRef, protected userContextSvc: UserContextService, protected http: HttpClient) {
    super(globalContext, userContextSvc, http);
    this.svcUrl += "WorkflowTags/";
  }

  validate(model: IWorkflowTag): IEntityValidation {
    let res: IEntityValidation = { Valid: true };
    let valid = !(!model.Title
    );
    if (!valid) {
      res.Valid = false;
      res.Message = 'Не заполнены обязательные поля';
      return res;
    }
    return res;
  }

  loadDictionary(): Promise<IPageableList<IWorkflowTag>> {
    let query: IWorkflowTagQuery = {}
    query.Skip = 0;
    query.IsDeleted = false;
    return this.fetchPaged(query).toPromise();
  }

  getDictionaryFromList(): IDictionary[] {
    let list = AppSettings.idea.status.list;
    let res: IDictionary[] = [];
    if (!list || list.length < 1)
      return res;
    for (var i = 0; i < list.length; i++) {
      var listItem = list[i];
      var dictItem = { Id: listItem.value, Title: listItem.label, disabled: listItem.disabled };
      res.push(dictItem);
    }
    return res;
  }

}
